import { render, staticRenderFns } from "./TheFieldMapping.vue?vue&type=template&id=41208508&scoped=true&"
import script from "./TheFieldMapping.vue?vue&type=script&lang=js&"
export * from "./TheFieldMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41208508",
  null
  
)

export default component.exports